/**
* description:
* Mutation types for Services Vuex Module
*
* data : 2017-08-23
*/

export const COMPLETE_LIST = 'COMPLETE_LIST';
export const COMPLETE_CATEGORIES_LIST = 'COMPLETE_CATEGORIES_LIST';
export const COMPLETE_BANNERS_LIST = 'COMPLETE_BANNERS_LIST';
export const TOGGLE_SERVICE_STATUS_CHANGE_RESULT = 'TOGGLE_SERVICE_STATUS_CHANGE_RESULT';
export const SET_SERVICE_STATUS_CONFIRMATION_REQUIRED = 'SET_SERVICE_STATUS_CONFIRMATION_REQUIRED';
export const CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED = 'CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED';
export const CLEAR_SERVICE_STATUS_CHANGE_RESULT = 'CLEAR_SERVICE_STATUS_CHANGE_RESULT';
export const SET_RESPONSE_CODE = 'SET_RESPONSE_CODE';
export const CLEAR_RESPONSE_CODE = 'CLEAR_RESPONSE_CODE';
export const TOOGLE_SERVICES_LIST_LOADING = 'TOOGLE_SERVICES_LIST_LOADING';
export const TOOGLE_CHANGE_STATUS_LOADING = 'TOOGLE_CHANGE_STATUS_LOADING';
export const TOOGLE_GET_USAGE_LOADING = 'TOOGLE_GET_USAGE_LOADING';
export const COMPLETE_PACKAGE_USAGE = 'COMPLETE_PACKAGE_USAGE';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';



// WEBPACK FOOTER //
// ./src/store/modules/Services/mutation-types.js